import React from 'react';
import { HTMLMotionProps, motion } from 'motion/react';

type AnimationWrapperProps<T extends keyof HTMLElementTagNameMap> = HTMLMotionProps<T> & {
  delay?: number;
  stagger?: number;
};

export const AnimationWrapper = (props: AnimationWrapperProps<'div'>) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{
      duration: 0.25,
      ease: 'easeInOut',
      delay: props.delay || 0,
      staggerChildren: props.stagger || 0,
    }}
    {...props}
  />
);

export const AnimationWrapperInline = (props: AnimationWrapperProps<'span'>) => (
  <motion.span
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{
      duration: 0.25,
      ease: 'easeInOut',
      delay: props.delay || 0,
      staggerChildren: props.stagger || 0,
    }}
    {...props}
  />
);

export const AnimationWrapperLi = (props: AnimationWrapperProps<'li'>) => (
  <motion.li
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{
      duration: 0.25,
      ease: 'easeInOut',
      delay: props.delay || 0,
    }}
    {...props}
  />
);

export const AnimationWrapperOl = (props: AnimationWrapperProps<'ol'>) => (
  <motion.ol
    initial={{ opacity: 0, scale: 0.95 }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{
      duration: 0.25,
      ease: 'easeInOut',
      delay: props.delay || 0,
      staggerChildren: 0.15,
    }}
    {...props}
  />
);
